import React from 'react'
import '../../styles/portfolio.css';
import { useSelector } from 'react-redux';
import { PageHeading, PageLine } from '../../componetns';
import IhunarImg from '../../images/ihunar-clone.png'
import piaicImg from '../../images/piaic-clone.png'
import softImg from '../../images/soft-mockup.PNG'
import sleepCoach from '../../images/sleep-coach.png'
import { IoIosLink } from "react-icons/io";
import { FaReact } from "react-icons/fa";
const Portfolio = () => {
	const { isDark } = useSelector((state) => state.useReducer);
	const portfolioCard = [
		{
			cardImg: IhunarImg,
			name: "Ihunar website clone",
			Url: "https://ihunar-web.vercel.app/"
		},
		{
			cardImg: piaicImg,
			name: "PIAIC website clone",
			Url: "https://piaic-web-clone.vercel.app/"
		},
		{
			cardImg: softImg,
			name: "website clone",
			Url: "https://soft-web.vercel.app/"
		},
		{
			cardImg: sleepCoach,
			name: "Sleep Coach wordpress website",
			Url: "https://soundasleepguru.com/"
		},
	]
	const handleIconClick = (url) => {
		window.open(url, "_blank");
	};
	return (
		<div className='postfolio-main' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }} name="portfolio">
			<PageLine />
			<PageHeading heading="Portfolio" />
			<div className='container'>
				<div className='row' id='card-row'>
					{portfolioCard.map((item, index) => {
						return (
							<div className='col-12 col-md-4 card-container' key={index}>
								<div style={{ backgroundColor: `${isDark ? "#3F51B5" : "#eaeaea"}`, boxShadow: `${isDark ? "#3F51B5 0px 5px 5px" : "#3F51B5 0px 5px 5px"}` }}  data-aos="zoom-in-down">
									<figure>
										<img src={item.cardImg} alt="card" />
										<figcaption>
											<div className="project-content" >
												<p>{item.name}</p>
												<div>
													{/* <FaReact className='portfolio-link-icon' style={{ cursor: "default" }} /> */}
													<IoIosLink className='portfolio-link-icon' onClick={() => handleIconClick(item.Url)} />
												</div>
											</div>
										</figcaption>
									</figure>
								</div>
							</div>
						)
					})}

				</div>
			</div>
		</div>
	)
}

export default Portfolio
